import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React from 'react'
import SimpleRadioButtonFieldSet from 'components/common/SimpleRadioButtonFieldSet/SimpleRadioButtonFieldSet'
import { THEME_DARK } from 'constants.js'
import { useForm } from 'hooks/use-form'
import { useStyles } from './styles'

export const PriorityListMetaForm = ({ artist, priorityListUser, updatePriorityListUser, ipv4 }) => {
    const classes = useStyles()

    const submitEmailHandler = async vals =>
        await updatePriorityListUser(artist._id, priorityListUser._id, {
            ageRange: vals.ageRange,
            newFan: vals.newFan,
            ipv4,
        })

    const { handleSubmit, eventHandlers } = useForm(
        'prioritylistmeta',
        { ageRange: '', newFan: '' },
        submitEmailHandler,
    )

    return (
        <div className={classes.container}>
            <form onSubmit={handleSubmit}>
                <p className={classes.headline}>Confirmed. You're in!</p>

                <div className={classes.question}>
                    <SimpleRadioButtonFieldSet
                        fieldSetId={'age'}
                        themeColor={THEME_DARK}
                        onChange={eventHandlers.ageRange}
                        fieldSetLabel={'How old are you?'}
                        buttons={[
                            { btnText: 'Under 18' },
                            { btnText: '19-25' },
                            { btnText: '26-30' },
                            { btnText: '31+' },
                        ]}
                    />
                </div>

                <div className={classes.question}>
                    <SimpleRadioButtonFieldSet
                        fieldSetId={'newFan'}
                        themeColor={THEME_DARK}
                        onChange={eventHandlers.newFan}
                        fieldSetLabel={`Have you seen ${artist.name} live before?`}
                        buttons={[{ btnText: `Yes, I'm obsessed` }, { btnText: 'No, not yet!' }]}
                    />
                </div>

                <div className={classes.submitBtn}>
                    <CallToActionButton onClick={handleSubmit} type="secondary" display="block" text="Submit" />
                </div>

                <input style={{ display: 'none' }} type="submit" />
            </form>
        </div>
    )
}

export default React.memo(PriorityListMetaForm)
